
const handleFetchHolidaysFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.holidays = action.payload.data;
  state.currentPage = action.payload.current_page;
  state.totalPages = action.payload.total_pages;
  state.perPage = action.payload.limit;
  state.totalHolidays = action.payload.total_holiday_list_count;
  state.lastUpdated = action.payload.last_updated;
  state.message = action.payload.message;
};

const handleFetchHolidayListByStatusFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.holidayListByStatus = action.payload.data;
};

const handleFetchOfficialHolidaysFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.officialHolidays = action.payload;
}

const handleAddHolidayFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.holidays.push(action.payload.data);
  state.message = action.payload.message;
};

const handleFetchHolidayByIdFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentHoliday = action.payload.data;
};

const handleUpdateHolidayFulfilled = (state, action) => {
  state.status = 'succeeded';
  const updatedHolidayIndex = state.holidays.findIndex(holiday => holiday.id === action.payload.data.id);
  if (updatedHolidayIndex !== -1) {
    state.holidays[updatedHolidayIndex] = action.payload.data;
  }
  state.currentHoliday = action.payload.data;
  state.message = action.payload.message;
};


export {
  handleFetchHolidaysFulfilled,
  handleFetchHolidayListByStatusFulfilled,
  handleFetchOfficialHolidaysFulfilled,
  handleAddHolidayFulfilled,
  handleFetchHolidayByIdFulfilled,
  handleUpdateHolidayFulfilled
};
